import React from 'react'
import { Header } from '../../../components/common/Header'

import '../index.less'
import { ModalRecoveryKey } from '../../../components/user/ModalRecoveryKey'
import { DoctorsDirectory } from '../../../components/doctors/DoctorsDirectory'

export default function DoctorsPage() {
  return (
    <div className="Dashboard">
      <Header />
      <DoctorsDirectory />
      <ModalRecoveryKey />
    </div>
  )
}
